import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Tavola } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Tavola>()

export function TableTavole({
  tavole,
  setFilters,
  filters,
  count,
  fullCount,
  actionLink,
}: {
  tavole: Tavola[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  actionLink?: (v?: Tavola) => void
}) {
  const numPages = useMemo(() => {
    if (!tavole) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [tavole, count])

  return (
    <Table
      data={tavole}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="titolo_completo"
        sortable
        width="400px"
        render={(item) =>
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(item)} style={{ cursor: "pointer" }}>
              {item.titolo}
            </LinkMagik>
          ) : (
            <Link to={`/atlanti/tavole/${item.id}`}>
              <LinkMagik className="text-dark">{item.titolo}</LinkMagik>
            </Link>
          )
        }
        stickyLeft
      />

      <Table.Column
        title="Immagine"
        name="immagine_principale_data"
        sortable
        width="minmax(max-content, 1fr)"
        render={(item) => 
          item.immagine_principale_data ? (
            <img
              src={item.immagine_principale_data.immagine_medium}
              alt={item.titolo}
              style={{ height: 80 }}
            />
          ) : (
            "N/A"
          )
        }
      />
      
      <Table.Column
        title="Bozza"
        name="bozza"
        sortable
        width="minmax(max-content, 1fr)"
        render={(item) => (item.bozza ? "Si" : "No")}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} tavole
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
